(() => {
    const root = document.getElementById('sp-modal');
    const host = document.getElementById('sp-modal-host');
    if (!root || !host) return;

    const cfg = {
        widgetId: root.dataset.widgetId,
        searchRadius: Number(root.dataset.searchRadius) || 150,
        defaultServiceRadius: Number(root.dataset.defaultServiceRadius) || 55,
        serviceRadiusField: root.dataset.serviceRadiusField || 'service_radius',
        title: root.dataset.title || 'Find Us In Store',
        sideImageToken: root.dataset.sideImageToken || 'popup_side_image',
        locatorUrl: root.dataset.locatorUrl || '/pages/find-a-store',
        tags: (root.dataset.tags || '').split(',').map(s => s.trim()).filter(Boolean),
        repeatDays: Number(root.dataset.repeatDays) || 0,
    };
    const STORAGE_KEY = 'sp_popup_last_shown';
    const DEFAULT_STORE_IMAGE = 'https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Default-Store-Image-Drawing-light.jpg?v=1784805066';
    const repeatMs = cfg.repeatDays * 864e5;
    const announcementSection = document.querySelector('[data-store-locator-bar-section]');
    const autoPopupEnabled = true;
    const hideAnnouncementOutOfRange = announcementSection?.dataset.hideStoreLocatorMessageOutOfRange === 'true';
    let lastShownAt = 0;
    try {
        lastShownAt = Number(localStorage.getItem(STORAGE_KEY) || 0);
    } catch {}
    const suppressAutoOpen = repeatMs && Date.now() - lastShownAt < repeatMs;
    const AUTO_POPUP_ATTENTIVE_DELAY = 5000;
    let autoPopupDelayElapsed = false;
    let storepointInitScheduled = false;
    let nearbyStoresAvailable = false;

    if (autoPopupEnabled && !suppressAutoOpen) {
        watchForAttentiveClose(attentiveWasShown => {
            scheduleStorepointInit();
            setTimeout(() => {
                autoPopupDelayElapsed = true;
                tryAutoOpen();
            }, attentiveWasShown ? AUTO_POPUP_ATTENTIVE_DELAY : 0);
        });
    }

    // data-sp="name" → $.name references the element.
    const $ = {};
    root.querySelectorAll('[data-sp]').forEach(el => { $[el.dataset.sp] = el; });
    $.title.textContent = cfg.title;

    $.close.addEventListener('click', close);
    root.addEventListener('click', e => { if (e.target === root) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !root.hidden) close(); });
    document.addEventListener('click', handleTriggerClick);

    // Storepoint's global is timing-safe: .on() queues until embed.js loads.
    const Storepoint = window.Storepoint ||= { _q: [], on(evt, cb) { this._q.push([evt, cb]); } };

    if (cfg.tags.length) {
        Storepoint.on('load', () => Storepoint.setFilters?.(cfg.tags));
    }


    const MAX_STORES = 3;
    let done = false;
    let stores = [];

    Storepoint.on('search', (data = {}) => {
        if (done) return;
        if (Number.isFinite(data.distance) && data.distance > cfg.searchRadius) {
            setNearRetailer(false);
            updateAnnouncementBar(false);
            return;
        }
        // Wait a frame so getCurrentLocations() reflects the post-search state.
        requestAnimationFrame(() => {
            stores = nearestStores(Storepoint.getCurrentLocations?.() || []);
            const isNear = stores.length > 0;
            nearbyStoresAvailable = isNear;
            setNearRetailer(isNear);
            updateAnnouncementBar(isNear);
            tryAutoOpen();
        });
    });

    updateAnnouncementBar(readNearRetailer());

    window.StorepointPopup = Object.assign(window.StorepointPopup || {}, {
        open() {
            initStorepointWidget();
            if (!stores.length) return false;
            open();
            return true;
        },
        close,
    });

    let storepointInitPromise = null;
    if ((autoPopupEnabled && !suppressAutoOpen) || hideAnnouncementOutOfRange) scheduleStorepointInit();

    function initStorepointWidget() {
        if (storepointInitPromise) return storepointInitPromise;
        storepointInitPromise = Promise.resolve(window.RetiqueGeoLocatorOverride?.getCoordinates?.()).then(testCoordinates => loadEmbed().then(() => testCoordinates)).then(testCoordinates => {
            if (!cfg.widgetId || typeof window.StorepointWidget !== 'function') return;
            window.RetiqueGeoLocatorOverride?.applyStorepointUrlOverride?.(testCoordinates);
            // GPS permission is a widget-wide setting; deny it during init so the widget
            // falls back to IP-based geolocation without prompting. Restored shortly
            // after so unrelated code on the host page can still request GPS.
            const hasTestCoordinates = Number.isFinite(testCoordinates?.latitude) && Number.isFinite(testCoordinates?.longitude);
            const restoreGeolocation = hasTestCoordinates ? () => {} : suppressGeolocation();
            const initialState = {
                auto_detect_location: !hasTestCoordinates,
                radius: cfg.searchRadius,
                search_text: window.RetiqueGeoLocatorOverride?.testZipcode || undefined,
            };

            if (hasTestCoordinates) {
                initialState.lat = testCoordinates.latitude;
                initialState.lng = testCoordinates.longitude;
            }

            new window.StorepointWidget(cfg.widgetId, '#' + host.id, {
                defaultView: 'none',
                mapOptions: { disabled: true },
                initialState,
            });
            setTimeout(restoreGeolocation, 2000);
        }).catch(() => {
            storepointInitPromise = null;
        });
        return storepointInitPromise;
    }

    function scheduleStorepointInit() {
        if (storepointInitScheduled) return;
        storepointInitScheduled = true;
        const start = () => {
            const delay = isMobile() ? 12000 : 6000;
            setTimeout(() => {
                if ('requestIdleCallback' in window) {
                    window.requestIdleCallback(() => initStorepointWidget(), { timeout: 3000 });
                } else {
                    initStorepointWidget();
                }
            }, delay);
        };

        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, { once: true });
    }

    function isMobile() {
      if (
        navigator.userAgentData &&
        typeof navigator.userAgentData.mobile === "boolean"
      ) {
        return navigator.userAgentData.mobile;
      }

      if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
        return true;
      }

      const ua = navigator.userAgent || "";
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(
        ua
      );
    }

    function open() {
        done = true;
        render();
        root.hidden = false;
        document.body.style.overflow = 'hidden';
        $.close.focus();
        if (repeatMs) try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch {}
    }

    function tryAutoOpen() {
        if (!done && nearbyStoresAvailable && autoPopupEnabled && !suppressAutoOpen && autoPopupDelayElapsed && root.hidden) {
            open();
        }
    }

    function watchForAttentiveClose(onClose) {
        let attentiveWasOpen = isAttentiveOpen();
        let closeDetected = false;
        const fallbackTimer = setTimeout(() => {
            if (attentiveWasOpen || closeDetected) return;
            closeDetected = true;
            observer.disconnect();
            onClose(false);
        }, AUTO_POPUP_ATTENTIVE_DELAY);
        const observer = new MutationObserver(() => {
            const attentiveIsOpen = isAttentiveOpen();

            if (attentiveWasOpen && !attentiveIsOpen && !closeDetected) {
                closeDetected = true;
                clearTimeout(fallbackTimer);
                observer.disconnect();
                onClose(true);
            }

            attentiveWasOpen ||= attentiveIsOpen;
        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'hidden', 'style'],
        });
    }

    function isAttentiveOpen() {
        const frame = document.getElementById('attentive_creative');
        if (!frame || frame.hidden) return false;

        const style = window.getComputedStyle(frame);
        return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
    }

    function render() {
        const [loc, ...others] = stores;
        if (!loc) return;
        const name = loc.name || 'Store location';
        const sideImage = customField(loc, cfg.sideImageToken);
        const address = addressText(loc);
        const phone = phoneText(loc);

        $.name.textContent = name;
        fill($.distance, formatDistance(loc.distance), (el, v) => { el.textContent = v; });
        fill($.address, address, (el, v) => { el.textContent = v; });
        fill($.phone, phone, (el, v) => {
            el.replaceChildren(Object.assign(document.createElement('a'), {
                href: 'tel:' + String(v).replace(/[^+\d]/g, ''),
                textContent: v,
            }));
        });
        setStoreImage($.logoWrap, $.logo, loc, `${name} logo`);
        setImage($.mediaWrap, $.sideImage, sideImage, `${name} storefront`);
        $.thumbs.hidden = !others.length;
        $.thumbs.replaceChildren(...others.map(thumb));

        root.classList.toggle('sp-modal--single', !sideImage);
        $.directions.href = locatorHref(loc);
    }

    function formatDistance(d) {
        return Number.isFinite(d) ? `${d.toFixed(1)} mi away` : '';
    }

    function nearestStores(locations) {
        return locations
            .filter(loc => {
                const max = Number(customField(loc, cfg.serviceRadiusField)) || cfg.defaultServiceRadius;
                return !Number.isFinite(loc.distance) || loc.distance <= max;
            })
            .filter(loc => matchesTags(loc, cfg.tags))
            .sort(compareStores)
            .slice(0, MAX_STORES);
    }

    // Sort order: API priority (higher wins) → tag `priority_N` (lower N wins) → distance.
    function compareStores(a, b) {
        const ap = apiPriority(a), bp = apiPriority(b);
        if (ap !== bp) {
            if (ap == null) return 1;
            if (bp == null) return -1;
            return bp - ap;
        }
        const td = tagPriority(a) - tagPriority(b);
        if (td !== 0) return td;
        return (a.distance ?? Infinity) - (b.distance ?? Infinity);
    }

    function apiPriority(loc) {
        const n = Number(loc.priority);
        return loc.priority != null && Number.isFinite(n) ? n : null;
    }

    function tagPriority(loc) {
        for (const t of String(loc.tags || '').split(',')) {
            const m = /^priority_(\d+)$/i.exec(t.trim());
            if (m) return Number(m[1]);
        }
        return Infinity;
    }

    function setNearRetailer(isNear) {
        if (isNear) {
            const desktopValue = "nrDesktop";
            const mobileValue = "nrMobile";

            const key = "utm_content";
            const value = isMobile() ? mobileValue : desktopValue;
            const url = new URL(window.location.href);

            if (url.searchParams.get(key) !== value) {
                url.searchParams.set(key, value);
                window.history.replaceState({}, "", url.toString());
            }
        }
        try { sessionStorage.setItem('near_retailer', isNear ? 'true' : 'false'); } catch {}
    }

    function readNearRetailer() {
        try {
            const value = sessionStorage.getItem('near_retailer');
            return value === 'true' ? true : value === 'false' ? false : null;
        } catch {
            return null;
        }
    }

    function updateAnnouncementBar(isNear) {
        if (!announcementSection || !hideAnnouncementOutOfRange || isNear === null) return;

        const storeItem = announcementSection.querySelector('[data-store-locator-message-item]');
        if (!storeItem) return;

        storeItem.hidden = !isNear;

        const fallbackItem = announcementSection.querySelector('.announcement-bar__item:not(.announcement-bar__item--store)');
        if (fallbackItem && !isNear) {
            fallbackItem.hidden = false;
        } else if (fallbackItem && isNear) {
            fallbackItem.hidden = true;
        }

        const visibleItem = announcementSection.querySelector('.announcement-bar__item:not([hidden])');
        announcementSection.hidden = !visibleItem;

        const sectionWrapper = announcementSection.closest('[id^="shopify-section-"]');
        if (sectionWrapper) {
            document.documentElement.style.setProperty('--announcement-bar-height', `${sectionWrapper.clientHeight}px`);
        }
    }

    function matchesTags(loc, tags) {
        if (!tags.length) return true;
        const raw = Array.isArray(loc.tags) ? loc.tags.join(',') : String(loc.tags || '');
        const locTags = raw.split(',').map(t => t.trim().toLowerCase()).filter(Boolean);
        return tags.some(t => locTags.includes(t.toLowerCase()));
    }

    function addressText(loc) {
        if (typeof loc.address === 'string') return loc.address;
        if (typeof loc.address?.formatted === 'string') return loc.address.formatted;
        return [
            loc.address?.street,
            loc.address?.street2,
            [loc.address?.city, [loc.address?.state, loc.address?.postalCode].filter(Boolean).join(' ')].filter(Boolean).join(', '),
        ].filter(Boolean).join('\n');
    }

    function phoneText(loc) {
        return loc.phone || loc.contact?.phone || '';
    }

    function thumb(loc) {
        const node = document.createElement('div');
        node.className = 'sp-modal__thumb';

        const imageWrap = document.createElement('div');
        imageWrap.className = 'sp-modal__thumb-image';
        const thumbImage = document.createElement('img');
        imageWrap.append(thumbImage);
        setStoreImage(imageWrap, thumbImage, loc, '');

        const copy = document.createElement('div');
        copy.className = 'sp-modal__thumb-copy';
        copy.append(
            Object.assign(document.createElement('div'), {
                className: 'sp-modal__thumb-name',
                textContent: loc.name || 'Store location',
            }),
            Object.assign(document.createElement('div'), {
                className: 'sp-modal__thumb-distance',
                textContent: formatDistance(loc.distance),
            })
        );

        const link = Object.assign(document.createElement('a'), {
            className: 'sp-modal__thumb-link',
            href: locatorHref(loc),
            textContent: '→',
            ariaLabel: `Get directions to ${loc.name || 'this store'}`,
        });

        node.append(imageWrap, copy, link);
        return node;
    }

    function close() {
        root.hidden = true;
        document.body.style.overflow = '';
    }

    function handleTriggerClick(event) {
        const trigger = event.target.closest('[data-sp-open]');
        if (!trigger) return;

        if (stores.length) {
            event.preventDefault();
            open();
            return;
        }

        if (!trigger.getAttribute('href') && cfg.locatorUrl) {
            event.preventDefault();
            window.location.href = cfg.locatorUrl;
        }
    }

    function fill(node, value, populate) {
        node.hidden = !value;
        if (value) populate(node, value);
    }

    function setImage(wrap, img, url, alt) {
        wrap.hidden = !url;
        if (!url) return;
        img.onerror = () => { wrap.hidden = true; };
        img.src = url;
        img.alt = alt;
    }

    function setStoreImage(wrap, img, loc, alt) {
        const imageUrl = mediaUrl(loc.image_url);
        setImage(wrap, img, hasSupportedImageExtension(imageUrl) ? imageUrl : DEFAULT_STORE_IMAGE, alt);
    }

    function hasSupportedImageExtension(value) {
        try {
            return /\.(?:jpg|png)$/i.test(new URL(value, window.location.href).pathname);
        } catch {
            return false;
        }
    }

    function customField(loc, target) {
        const key = normalizeKey(target);
        if (!key) return '';
        const groupedFields = Object.values(loc.custom_fields || {})
            .flatMap(group => Array.isArray(group) ? group : Array.isArray(group?.items) ? group.items : []);
        const directFields = Array.isArray(loc.customFields) ? loc.customFields : [];
        const match = [...directFields, ...groupedFields]
            .find(field => field && [field.token, field.key, field.label, field.name].some(v => normalizeKey(v) === key));
        return mediaUrl(match?.value);
    }

    function normalizeKey(value) {
        return String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
    }

    function mediaUrl(value) {
        if (!value) return '';
        if (typeof value === 'string') return value.trim();
        if (Array.isArray(value)) return mediaUrl(value[0]);
        return mediaUrl(
            value.url || value.src || value.image_url || value.file_url || value.image || value.file || value.media
            || value.asset || value.data || value.value || value.files?.[0] || value.items?.[0]
        );
    }

    function locatorHref(loc) {
        const params = new URLSearchParams();
        if (loc.id) params.set('location', loc.id);
        if (loc.loc_lat && loc.loc_long) {
            params.set('lat', loc.loc_lat);
            params.set('lng', loc.loc_long);
        }
        return `${cfg.locatorUrl}?${params}`;
    }

    function suppressGeolocation() {
        const geo = navigator.geolocation;
        if (!geo) return () => {};
        const original = { getCurrentPosition: geo.getCurrentPosition, watchPosition: geo.watchPosition };
        const deny = (_, error) => error?.({ code: 1, PERMISSION_DENIED: 1, message: 'Suppressed' });
        geo.getCurrentPosition = deny;
        geo.watchPosition = deny;
        return () => Object.assign(geo, original);
    }

    function loadEmbed() {
        if (window.StorepointWidget) return Promise.resolve();
        return new Promise((resolve, reject) => {
            const existing = document.querySelector('script[data-sp-embed]');
            const script = existing || Object.assign(document.createElement('script'), {
                src: 'https://widget.storepoint.co/embed.js',
                async: true,
            });
            script.dataset.spEmbed = 'true';
            script.addEventListener('load', resolve, { once: true });
            script.addEventListener('error', reject, { once: true });
            if (!existing) document.head.appendChild(script);
        });
    }
})();
